import { SmartInput } from 'app/components/shared/FormComponents/SmartInput'
import { FormGroup } from 'app/components/shared/FormGroup'
import { FormSection } from 'app/components/shared/FormSection'
import { Grid } from 'app/components/ui/Grid'
import { Input } from 'app/components/ui/Input'
import { Label } from 'app/components/ui/Label'
import React from 'react'
import { useFormContext } from 'react-hook-form'

export const PrimaryBankDetailsFormSection = (): JSX.Element => {
  const { getValues, setValue } = useFormContext()

  const makeFieldName = (fieldName: string) => `bank_account_1.${fieldName}`

  return (
    <>
      <FormSection title='Coordinate bancarie'>
        <Grid cols={[4, 4, 4]}>
          <FormGroup>
            <SmartInput
              label='Banca'
              name={makeFieldName('bank')}
              labelRequired
            />
          </FormGroup>
          <FormGroup>
            <SmartInput
              label='Agenzia / Filiale'
              name={makeFieldName('agency')}
              labelRequired
            />
          </FormGroup>
          <FormGroup>
            <SmartInput
              label='IBAN'
              name={makeFieldName('iban')}
              labelRequired
              onChange={() =>
                setValue(
                  'bank_account_1.iban',
                  getValues('bank_account_1.iban').replace(/\s/g, '')
                )
              }
            />
          </FormGroup>
        </Grid>
        {/* read only */}
        <Grid cols={[4, 4, 4]}>
          <div>
            <Label htmlFor='ba_company_name'>Ragione Sociale</Label>
            <Input
              onChange={() => null}
              readOnly
              value={getValues('company_name')}
              id='ba_company_name'
            />
          </div>
          <div>
            <Label htmlFor='ba_company_fiscal_code'>Codice fiscale</Label>
            <Input
              onChange={() => null}
              readOnly
              value={getValues('company_fiscal_code')}
              id='ba_company_fiscal_code'
            />
          </div>
          <div>
            <Label htmlFor='ba_company_p_iva'>Partita Iva</Label>
            <Input
              onChange={() => null}
              readOnly
              value={getValues('company_vat')}
              id='ba_company_p_iva'
            />
          </div>
        </Grid>
      </FormSection>

      <FormSection title='Persona delegata ad operare sul CC'>
        <Grid cols={[6, 6]}>
          <FormGroup>
            <SmartInput
              label='Nome'
              name={makeFieldName('delegated_name')}
              labelRequired
            />
          </FormGroup>
          <FormGroup>
            <SmartInput
              label='Cognome'
              name={makeFieldName('delegated_surname')}
              labelRequired
            />
          </FormGroup>
        </Grid>
        <Grid cols={[6, 6]}>
          <FormGroup>
            <SmartInput
              label='Codice Fiscale'
              name={makeFieldName('delegated_fiscal_code')}
              labelRequired
            />
          </FormGroup>
          <FormGroup>
            <SmartInput
              label='Ruolo'
              name={makeFieldName('delegated_role')}
              labelRequired
            />
          </FormGroup>
        </Grid>
      </FormSection>
    </>
  )
}
